import { render, staticRenderFns } from "./ThereIsBookGotTitle.vue?vue&type=template&id=31f96848&scoped=true"
import script from "./ThereIsBookGotTitle.vue?vue&type=script&lang=js"
export * from "./ThereIsBookGotTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f96848",
  null
  
)

export default component.exports